// @flow

export { BoletoPendingPage } from './boleto-pending-page'; 
